import { Component } from '@angular/core';
import { ButtonSettings } from 'src/app/models/button-settings.model';
import { AccessibilityService } from 'src/app/services/accessibility.service';

import { CardButtonComponent } from '../../shared-modules/card-button/card-button.component';
import { CardButtonWordDownloadComponent } from '../../shared-modules/card-button-word-download/card-button-word-download.component';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    imports: [CardButtonComponent, CardButtonWordDownloadComponent]
})
export class LandingPageComponent {
  public readonly id: string = AccessibilityService.defaultContentId;

  public buttonSettings: ButtonSettings[] = [
    {
      fontIcon: 'list_alt',
      label: 'Gegevens huidige situatie',
      routerLink: '/items/current/data'
    },
    {
      fontIcon: 'forum',
      label: 'Beoordeling huidige situatie',
      routerLink: '/items/current/evaluate'
    },
    {
      fontIcon: 'dataset',
      label: 'Resultaten - Beeldvorming huidige situatie',
      routerLink: '/results/current'
    },
    {
      fontIcon: 'list_alt',
      label: 'Gegevens toekomstige situatie',
      routerLink: '/items/future/data'
    },
    {
      fontIcon: 'forum',
      label: 'Bepalen ambitieniveau',
      routerLink: '/items/future/evaluate'
    },
    {
      fontIcon: 'dataset',
      label: 'Resultaten - Beeldvorming toekomstige situatie',
      routerLink: '/results/future'
    },
    {
      fontIcon: 'insights',
      label: 'Resultaten - Spiderweb',
      routerLink: '/spiderweb'
    }
  ]
}
